export const requestCORSIfNotSameOrigin = (img: HTMLImageElement, url: string | URL) => {
  if (new URL(url, window.location.href).origin !== window.location.origin) {
    img.crossOrigin = "anonymous";
  }
};
